import React from "react";
import { ProductPageTabHeaderProps } from "../../ProductPageTabHeaders";
import { TabHeader, useTabsContext } from "@vp/swan";
import { MarkdownTab } from "../../../types/ContentfulTypes";
import { SocialCurationsTabData, renderSocialCuration } from "./SocialCurationsHelper";

export const SocialCurationsHeader = (props: ProductPageTabHeaderProps) => {
  const { tab, tabIndex } = props;
  const { selectedTabId } = useTabsContext();

  const tabData = tab?.value as SocialCurationsTabData | MarkdownTab | undefined;
  const tabTitle = tabData?.resolvedDictionaryEntries?.[tabData?.tabTitleEntryId];

  if (!renderSocialCuration(tabData)) {
    return null;
  }

  return (
    <TabHeader
      tabId={tabIndex}
      inputProps={{
        //@ts-ignore
        "aria-selected": selectedTabId === tabIndex,
      }}
    >
      {tabTitle}
    </TabHeader>
  );
};
